const dealsCmsAPI = (country, lang, queryParam, postType = 'deal') => {
    const headersDealsApi = new Headers();
    headersDealsApi.append("accept", "*/*");
    headersDealsApi.append("accept-language", `${lang}-${country.toUpperCase()},${lang};q=0.9`);
    headersDealsApi.append("content-type", "application/json");
    headersDealsApi.append("wucountrycode", `${country.toUpperCase()}`);
    headersDealsApi.append("wulanguagecode", `${lang}`);
    headersDealsApi.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersDealsApi.append("x-wu-operationname", "deals");

    const dealsVariables = {
        "input": {
            "queryParameters": queryParam,
            "site": "deals",
            "postType": postType
        }
    };

    const graphql = JSON.stringify({
        query: dealsApiQuery,
        variables: dealsVariables
    });
    
    const requestOptions = {
        method: "POST",
        headers: headersDealsApi,
        body: graphql,
        redirect: "follow"
    };

    return fetch(routerUrl, requestOptions)
    .then((response) => response.text())
    .then((result) => {
        result = JSON.parse(result);
        const dealsRes = result?.data?.deals?.deals;
        return Promise.resolve({
            dealsData: dealsRes?.data || [],
            meta: dealsRes?.meta || {}
        });
    })
    .catch(error => {
  console.error(error);
  return { dealsData: [], meta: {} };
 });
}